import routes, {SPECIAL_CODES_ROUTE} from "./redirect-config";
import amplitudeLogRoute from "./amplitude-log-route";

const redirect = () => {
  window.localStorage?.setItem("needsRefresh", "yes");
  // Some NFC tags were written with trailing whitespace in the URL, which the
  // browser percent-encodes (e.g. "/gothambank%20"), so decode and trim
  // before matching against the route table.
  const pathname = decodeURIComponent(window.location.pathname).trim();
  const specialRoute = "/coins/";
  const isSpecialRoute = pathname.startsWith("/coins/");

  // Log analytics for route
  amplitudeLogRoute(pathname, {
    isBonusCoin: isSpecialRoute,
  });

  if (isSpecialRoute) {
    const trailingPath = pathname.substring(specialRoute.length)
    window.location.replace(routes[SPECIAL_CODES_ROUTE](trailingPath));
    return;
  }

  if (Object.keys(routes).indexOf(pathname) !== -1) {
    window.location.replace(routes[pathname]);
  } else if (routes.default) {
    if (pathname !== routes.default) {
      window.location.replace(routes.default);
    }
  } else {
    throw new Error("Redirect routes are not configured correctly");
  }
};

if (window.localStorage?.getItem("needsRefresh")) {
  window.localStorage?.removeItem("needsRefresh");
  window.location.reload();
} else {
  redirect();
}






